let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iXY8o")).then(() => parcelRequire('2yT3X'));